import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    TextField,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import ObjecttypeService from "../../../services/ObjecttypeService";

function EnumeratorDialog({ realm, token, open, onClose, row, typeGuid, setColumnData, fieldType }) {
    const [values, setValues] = useState(row?.enumeratorValues || []);

    useEffect(() => {
        if (row) setValues(row.enumeratorValues || []);
    }, [row]);

    const handleSave = async () => {
        try {
            await Promise.all(values.map(async (val) => {
                if (fieldType === 'administrativeobjectType') {
                    await ObjecttypeService.saveAdministrativeobjectTypeAttributeAllowedValue(typeGuid, row, val, token, realm);
                } else if (fieldType === 'realestateobjectType') {
                    await ObjecttypeService.saveRealestateobjectTypeAttributeAllowedValue(typeGuid, row, val, token, realm);
                }
            }));

            if (fieldType === 'administrativeobjectType') {
                const listFields = await ObjecttypeService.getAdministrativeobjectFields(typeGuid, token, realm);
                setColumnData(listFields?.data);
            } else if (fieldType === 'realestateobjectType') {
                const listFields = await ObjecttypeService.getRealestateobjectFields(typeGuid, token, realm);
                setColumnData(listFields?.data);
            }
        } catch (err) {
            console.error("Fehler beim Speichern der Aufzählung:", err);
        }

        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Aufzählung bearbeiten (Attribut {row?.label})</DialogTitle>
            <DialogContent>
                {values.map((val, idx) => (
                    <div key={val.guid} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                        <TextField
                            label="Text"
                            value={val.text}
                            onChange={(e) =>
                                setValues((prev) =>
                                    prev.map((v, i) => i === idx ? { ...v, text: e.target.value } : v)
                                )
                            }
                            fullWidth
                        />
                        <TextField
                            label="Value"
                            value={val.value}
                            onChange={(e) =>
                                setValues((prev) =>
                                    prev.map((v, i) => i === idx ? { ...v, value: e.target.value } : v)
                                )
                            }
                            fullWidth
                        />
                        <IconButton
                            color="error"
                            onClick={async () => {
                                try {
                                    if (fieldType === 'administrativeobjectType') {
                                        await ObjecttypeService.deleteAdministrativeobjectTypeAttributeAllowedValue(typeGuid, row, val, token, realm);
                                        const listFields = await ObjecttypeService.getAdministrativeobjectFields(typeGuid, token, realm);
                                        setColumnData(listFields?.data);
                                    } else if (fieldType === 'realestateobjectType') {
                                        await ObjecttypeService.deleteRealestateobjectTypeAttributeAllowedValue(typeGuid, row, val, token, realm);
                                        const listFields = await ObjecttypeService.getRealestateobjectFields(typeGuid, token, realm);
                                        setColumnData(listFields?.data);
                                    }
                                    setValues((prev) => prev.filter((_, i) => i !== idx));
                                } catch (err) {
                                    console.error("Fehler beim Löschen des Aufzählungswertes:", err);
                                }
                            }}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                ))}
                <Button
                    onClick={() =>
                        setValues((prev) => [
                            ...prev,
                            { text: "New Key", value: "New Value", guid: "" },
                        ])
                    }
                >
                    + Neu
                </Button>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button variant="contained" onClick={handleSave}>
                    Speichern
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EnumeratorDialog;
